import React from 'react';
import PropTypes from 'prop-types';
import { Price } from './price';
import { RowTwoCells } from './row_two_cells';
import { Label } from './shipping_price/label';
import { Checkbox } from '../../form/floating_label/checkbox';

export function CrossSellProducts({
  crossSellProd,
  currencyIsoCode,
  loading,
  onRemoveClick,
  onDetailsClick,
  onChangeCrossSellCheckbox,
}) {
  const handleChangeCrossSellCheckbox = (value, id) => {
    if (!value) {
      onRemoveClick({ preventDefault: () => {} }, crossSellProd);
    } else {
      onChangeCrossSellCheckbox(value, id);
    }
  };

  const crossSellLabel = (
    <>
      {crossSellProd.titleShort}
      {crossSellProd.productType !== 'tyre_stewardship' && !crossSellProd.showAddToCartInputElem && (
        <span style={{ marginLeft: '10px', cursor: 'pointer', verticalAlign: 'middle' }}>
          <svg
            onClick={(e) => onRemoveClick(e, crossSellProd)}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-trash"
            viewBox="0 0 16 16"
          >
            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
            <path
              fillRule="evenodd"
              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
            />
          </svg>
        </span>
      )}
    </>
  );
  const label = (
    <>
      {!crossSellProd.showAddToCartInputElem && crossSellLabel}
      {crossSellProd.showAddToCartInputElem && (
        <Checkbox
          key={`cross-sell-product-checkbox-${crossSellProd.spinachId}`}
          name={`cross-sell-product-checkbox-${crossSellProd.spinachId}`}
          checked={crossSellProd.preselected}
          onChange={(e, f) => handleChangeCrossSellCheckbox(e, f)}
          label={crossSellLabel}
        />
      )}
    </>
  );

  const labelExtraChildren = [
    <div
      className={crossSellProd.lightContentAvailable ? 'underline cursor-pointer' : ''}
      onClick={(e) => crossSellProd.lightContentAvailable && onDetailsClick(e, crossSellProd)}
    >
      {crossSellProd.descriptionShort}{' '}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: 'relative', top: '3px' }}
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-exclamation-circle"
        viewBox="0 0 16 16"
      >
        {' '}
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />{' '}
        <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />{' '}
      </svg>
    </div>,
  ];

  if (crossSellProd.price !== -1) {
    return (
      <Price
        key={`cross-sell-product-price-${crossSellProd.spinachId}`}
        name={`cross-sell-product-price-${crossSellProd.spinachId}`}
        label={label}
        labelExtraChildren={labelExtraChildren}
        price={crossSellProd.syncQty ? crossSellProd.price * crossSellProd.productQty : crossSellProd.price}
        loading={loading}
        currencyIsoCode={currencyIsoCode}
        leftClassName="cross-sell-product"
        middle={false}
        colspan={2}
      />
    );
  }

  return (
    <RowTwoCells
      key={`cross-sell-price-${crossSellProd.spinachId}`}
      name="cross-sell-price"
      left={<Label name="cross-sell-price" label={label} />}
    />
  );
}

CrossSellProducts.propTypes = {
  crossSellProd: PropTypes.object,
  currencyIsoCode: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  onDetailsClick: PropTypes.func.isRequired,
};

CrossSellProducts.defaultProps = {
  CrossSellProd: null,
};
